import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";
import { Input, Pagination, Table } from "antd";
import shortid from "shortid";

const { Search } = Input;

function TableCustom({
  columns,
  data,
  pageNumberDefault,
  pageSizeOptions,
  rowSelection,
  scroll,
  showPagination,
  showSearch,
  pageChange,
  pageSizeChange,
  pageSizeDefault
}) {
  const firstLoad = useRef(false)
  const firstLoadSize = useRef(false)
  const [pageNumber, setPageNumber] = useState(pageNumberDefault || 1);
  const [useData, setData] = useState(data);
  const [pageSize, setPageSize] = useState(
    pageSizeOptions ? parseInt(pageSizeOptions[0]) : 20
  );

  useEffect(() => {
    doPageData();

    if(pageNumberDefault !== pageNumber && !firstLoad.current){
      setPageNumber(pageNumberDefault || 1)
      firstLoad.current = true
    }

    if(pageSizeDefault !== pageSize && !firstLoadSize.current){
      setPageSize(pageSizeDefault || 12)
      firstLoadSize.current = true
    }

  }, [data, pageNumber, pageSize]);

  function doPageData() {
    const start = (pageNumber - 1) * pageSize;
    const end = (pageNumber - 1) * pageSize + pageSize;
    setData(_.slice(data, start, end));
  }

  function isDate(value) {

    const _regExp = new RegExp('^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?(Z)?$');
    var result = _regExp.test(value);

    return result;
  }

  function findValue(o, k, value) {
    if (!o[k])
      return false;

    if (isDate(o[k])) {
      return findValueInDate(o[k], value)
    }

    return false;
  }

  function findValueInDate(data, value) {
    data = data.split("T")[0];
    data = data.split("-");
    var newData = `${data[2]}/${data[1]}/${data[0]}`;

    return newData.includes(value)
  }

  function filterByValue(value) {
    const newData = _.filter(data, (o) =>
      _.some(
        Object.keys(o.Movimentacao),
        (k) => findValue(o.Movimentacao, k, value))
    );

    setData(newData);
    if (!value.length) setData(data);
  }

  const onChangePage = (value) => {
    setPageNumber(value)
    if(typeof(pageChange) === 'function'){
      pageChange(value)
    }
  }

  const onChangePageSize = (value) => {
    setPageSize(value)
    if(typeof(pageSizeChange) === 'function'){
      pageSizeChange(value)
    }
  }

  return (
    <>
      {showSearch !== false ? (
        <Search
          className="search-field"
          placeholder="Buscar pela competência, exemplo: 01/2020"
          onSearch={filterByValue}
        />
      ) : null}

      <Table
        className="ant-table--custom"
        dataSource={useData}
        columns={columns}
        rowKey={(record) => record.id || record.Id || shortid.generate()}
        pagination={false}
        rowSelection={rowSelection}
        scroll={scroll}
      />

      {showPagination !== false ? (
        <Pagination
          className="mt-3"
          showSizeChanger
          pageSizeOptions={pageSizeOptions || ["20", "50", "100"]}
          defaultPageSize={pageSize}
          pageSize={pageSize}
          defaultCurrent={pageNumber}
          current={pageNumber}
          total={data.length}
          showTotal={(total, range) =>
            `${range[0]}-${range[1]} de ${total} itens`
          }
          onChange={onChangePage}
          onShowSizeChange={(current, size) => {
            onChangePageSize(size);
            onChangePage(1);
          }}
        />
      ) : null}
    </>
  );
}

export default TableCustom;
